export default __webpack_public_path__ + "static/media/hands-in-the-air.0ca13d03.jpg";